import Box from '@/common/components/Box'
import BoxWithHeader from '@/common/components/BoxWithHeader'
import Skeleton from '@/common/components/Skeleton'

const MaintenanceWorkflowExecutionEntryExecutionLoading = () => {
  return (
    <div className="flex-1 flex gap-6">
      <div className="flex-1">
        <Box className="p-4 flex flex-col gap-4">
          <div className="flex gap-3">
            <Skeleton className="w-40 h-10" />
            <Skeleton className="w-56 h-10" />
          </div>

          <div className="flex flex-col gap-2">
            <Skeleton className="w-44 h-5" />

            <div className="flex flex-col gap-1.5">
              <Skeleton className="h-28 rounded-lg" />
              <Skeleton className="h-28 rounded-lg" />
              <Skeleton className="h-28 rounded-lg" />
            </div>
          </div>
        </Box>
      </div>

      <div>
        <BoxWithHeader title="Checklist" subtitle="">
          <div className="flex flex-col gap-2">
            <Skeleton className="w-48 h-5" />
            <Skeleton className="w-48 h-5" />
            <Skeleton className="w-48 h-5" />
          </div>
        </BoxWithHeader>
      </div>
    </div>
  )
}

export default MaintenanceWorkflowExecutionEntryExecutionLoading
